"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.claimPayeeSchema = void 0;
var constants_1 = require("../../constants");
exports.claimPayeeSchema = {
    type: 'object',
    additionalProperties: {
        not: true,
        errorMessage: '- should not have additional property ${0#}',
    },
    required: ['transitNumber', 'payeeID', 'typeCode', 'name'],
    properties: {
        name: {
            type: ['string', 'null'],
            minLength: 0,
            maxLength: 35,
            errorMessage: 'Should be a string with a maximum of 35 characters or null',
        },
        payeeID: {
            type: 'number',
            minimum: 0,
            maximum: 2147483647,
            errorMessage: 'Should be an integer between 0 and 2147483647',
        },
        transitNumber: {
            type: 'string',
            minLength: 5,
            maxLength: 5,
            errorMessage: 'Should be a string with 5 characters',
        },
        typeCode: {
            type: 'number',
            enum: Object.values(constants_1.ClaimPayeeType),
            errorMessage: 'Should equate to a valid ClaimPayeeType Enum value',
        },
    },
};
